import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn.mjs'
import 'element-plus/dist/index.css'
import { ZINDEX_INJECTION_KEY } from 'element-plus'

export default defineNuxtPlugin(nuxtApp => {
  // SSR 兼容：提供 z-index provider，避免 ElementPlusError: [ZIndexInjection]
  nuxtApp.vueApp.provide(ZINDEX_INJECTION_KEY, { current: 0 })
  nuxtApp.vueApp.use(ElementPlus, { 
    size: 'small', 
    locale: zhCn 
  })
})
